import React from 'react'
import { HtmlContent } from 'utils'

import styles from './styles/image_component.module.scss'

const ImageComponent = ({ title, description, image }) => {

  return (
    <section className={styles.image_component}>
      <div className={styles.image_component__text_wrapper}>
        {
          title !== ''
            ? <h2 className={styles.image_component__title}>
              {title}
            </h2>
            : null
        }

        {
          description !== ''
            ? <HtmlContent content={description} className={styles.image_component__text} />
            : null
        }
      </div>
      <div className={styles.image_component__img_wrapper}>
        <img loading="lazy"
          className={styles.image_component__img}
          src={image}
          alt=''
        />
      </div>
    </section>
  )
}

export default ImageComponent